<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row>
            <ion-col size="12" size-sm="10" offset-sm="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
                <div class="padding">

                    <div v-if="!isAuthenticated" class="text-left mt-10">
                        <button class="link" @click="goToLogin">
                            <span class="pd-0">&larr; Wróć do logowania</span>
                        </button>
                    </div>

                    <h1 class="text-center">Regulamin</h1>
                    <div v-if="loading" class="pd-20 text-center" style="width: 100%">
                      <span class="loader red"></span>
                    </div>
                    <div class="rte" v-html="rte"></div>

                    <div v-if="!isAuthenticated" class="text-left mt-10">
                        <button class="link" @click="goToLogin">
                            <span class="pd-0">&larr; Wróć do logowania</span>
                        </button>
                    </div>

                </div>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import api from '@/services/Api';

    export default {
        name: 'RegulationsIndex',
        data() {
            return {
                loading: false,
                rte: ''
            }
        },
        computed: {
            ...mapGetters(['isAuthenticated']),
        },
        mounted() {
            this.getRegulations()
        },
        methods: {
            getRegulations() {
                this.loading = true;
                let url = '/regulations'
                if(this.isAuthenticated) url = '/api/v1/regulations'
                api.get(url).then(response => {
                    this.loading = false;
                    this.rte = response.data.data.html
                })
            },
            goToLogin() {
                this.$router.push({name: 'Login'})
            }
        }
    }
</script>
